import ZeroStateHighlights from './ZeroStateHighlights';

export default ZeroStateHighlights;
